import TracingBezier from './TracingBezier.vue';
import TracingBezierList from './TracingBezierList.vue';
export default {
  TracingBezier,
  TracingBezierList,
};
